import { put, takeLatest, all, call } from "redux-saga/effects";
import { toast } from "react-toastify";

import {
  viewJsonFileFailure,
  viewJsonFileSuccess,
} from "../../actions";
import { VIEW_JSON_FILE } from "../../Actions/types";
import api from "../../../helper/api";

function* viewJsonFile(action) {
  try {
    const response = yield api.get(`/admin/glb/get-json-file`);
    if (response?.status === 200 && response?.data?.code === 200) {
      yield call(action?.payload?.callback, response?.data?.data);
      yield put(viewJsonFileSuccess({ getData: response?.data?.data }));
      toast.success(response?.data?.message);
    } else {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.message)
    yield put(viewJsonFileFailure({ getError: e }));
  }
}

function* viewJsonWatcher() {
  yield takeLatest(VIEW_JSON_FILE, viewJsonFile);
}

export default function* viewJsonSaga() {
  yield all([viewJsonWatcher()]);
}
